import { render } from "./CompanyDetails.vue?vue&type=template&id=54e62bd1"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__